export const INITIAL_LOADINGS: LoadingList = {
  APP_INIT: true,
  MOBILE_CHART_INIT: true,
};
